var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m28.564 23.062-4.804-4.43.77-.84 6.496 5.975v.466l-6.49 5.982-.776-.804 4.811-4.459c.152-.146.332-.258.53-.331H16.967v-1.235H29.1a1.6 1.6 0 0 1-.537-.324"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    x: 0.5,
    y: 0.5,
    stroke: "#65696A",
    rx: 23.5
  })));
};
export default SvgRightArrow;